import React, {Component} from 'react';
import styled from 'styled-components';
import {TableWrapperGrayHover} from 'components/table/components';
import PropTypes from 'prop-types';

export const TendersList = styled.ul`

  li {
    padding: 10px 0;
    border-bottom: 1px solid #f4f4f4;
  }
`;

class Table extends Component {
  render() {
    return(
      <TableWrapperGrayHover black={this.props.black} center={this.props.center} hover={this.props.hover}>
        {this.props.children}
      </TableWrapperGrayHover>
    )
  }
}
Table.propTypes = {
  children: PropTypes.node
}

export default Table;



// WEBPACK FOOTER //
// ./src/system/information-center/procurements/components.js